import BeforeAfter from 'components/shared/before-after/beforeAfter';
import styles from './imagesBeforeAfter.module.scss';

const ImagesBeforeAfter = ({ data }) => {
  const { title, text, componentsCollection, labelBefore, labelAfter } = data;
  const componentWidth = componentsCollection.length ? 100 / componentsCollection.length : 100;
  return (
    <section>
      <div className={styles.wrapper}>
        <div className={styles.titleAndTextWrapper}>
          {title && <h3 className={styles.title}>{title}</h3>}
          {text && <p className={styles.text}>{text}</p>}
        </div>

        <div className={styles.componentsWrapper}>
          {componentsCollection.map((item, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <div className={styles.componentContainer} key={`imagesBeforeAfterComponent${i}`}>
              <h3 className={styles.componentTitle}>{item.title}</h3>
              {item.text && <p className={styles.componentText}>{item.text}</p>}
              <BeforeAfter
                imageBefore={item.imageBefore}
                imageAfter={item.imageAfter}
                className={styles.beforeAfterContainer}
                labelBefore={labelBefore}
                labelAfter={labelAfter}
                widthDesktop={`calc(${componentWidth}vw - 12rem)`}
                widthMobile="calc(100vw - 6rem)"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImagesBeforeAfter;
